import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { burlingtonIAConfig } from "./data";

export default function BurlingtonIAPage() {
  return <CityPageTemplate config={burlingtonIAConfig} />;
}